module.exports = __webpack_public_path__ + "static/media/20210401_220129_697_IMG_0006.d4fc8656.jpg";